module.exports = __webpack_public_path__ + "img/taag3.29f96a1a.png";